<template>
  <div>
    <!-- sms mapping -->
    <b-modal
      id="modal-sms-mapping"
      cancel-variant="outline-secondary"
      hide-footer
      size="lg"
      centered
      title="SMS Settings"
      no-close-on-backdrop
    >
      <b-row>
        <b-col md="6">
          <b-form-group
            label="Send on"
            invalid-feedback="Send on is required."
            ref="send_on"
          >
            <v-select
              v-model="myObj.sendOn"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sendOptions"
              :reduce="(val) => val.value"
              label="text"
              :clearable="false"
              placeholder="send on"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Select SMS Number"
            invalid-feedback="SMS Number is required."
            ref="sms_temp"
          >
            <v-select
              v-model="myObj.smsSettingID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="smsOptions"
              :clearable="false"
              :disabled="smsLoading"
              label="title"
              :reduce="(val) => val.id"
              placeholder="Select number"
            >
              <template #option="option">
                <div v-b-tooltip.hover.top :title="`${option.title}`">
                  <div class="font-weight-bolder line-height-1">
                    {{ option.title }}
                  </div>
                  <div class="font-small-2">{{ option.number }}</div>
                </div>
              </template>
              <template #selected-option="option">
                <div>
                  <div class="font-weight-bolder line-height-1">
                    {{ option.title }}
                  </div>
                  <div class="font-small-2">{{ option.number }}</div>
                </div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label="Classes"
            invalid-feedback="Classes are required."
            ref="sel_cls"
          >
            <v-select
              multiple
              :closeOnSelect="false"
              v-model="myObj.classIDs"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="[{ id: 0, name: 'All Classes' }, ...classesOptions]"
              :reduce="(val) => val.id"
              :clearable="false"
              label="name"
              :disabled="clsLoading"
              placeholder="Select classes"
              @input="setClass()"
            />
          </b-form-group>
        </b-col>

        <b-col md="12" class="text-right">
          <b-button variant="success" @click="saveData()" :disabled="request">
            <b-spinner v-if="request" small type="grow" />
            <span v-else>{{$t('Save')}}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-card>
      <b-row class="mt-1">
        <b-col md="12">
          <b-button
            @click="$emit('close-comp')"
            class="mr-1 btn-icon"
            variant="outline-secondary"
            pill
            v-b-tooltip.hover.top
            title="Back"
          >
            <feather-icon icon="ChevronLeftIcon" size="20" />
          </b-button>

          <b-button @click="AddOpen()" variant="primary">
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">Config</span>
          </b-button>
        </b-col>

        <!-- <b-col
          class="mt-lg-0 mt-md-0 mt-sm-1 mt-1"
          xl="10"
          lg="9"
          md="8"
          sm="12"
        >
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model.trim="searchQuery"
                placeholder="Search by title..."
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col> -->
      </b-row>

      <b-table
        class="mt-1"
        :items="filters"
        :fields="fields"
        :busy="dataLoading"
        show-empty
        responsive
        hover
      >
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-3">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </div>
        </template>
        <template #cell(title)="data">
          <b-badge variant="light-primary">
            {{ data.item.title }}
          </b-badge>
        </template>
        <template #cell(number)="data">
          <b-badge variant="light-primary">
            {{ data.item.number }}
          </b-badge>
        </template>

        <template #head(actions)="data">
          <div class="text-center">
            <span>{{ data.label }}</span>
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="text-center">
            <b-button
              variant="primary"
              v-b-tooltip.hover.left
              title="Edit"
              class="btn-icon mr-1"
              @click="EditOpen(data.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BTable,
  BForm,
  BFormInput,
  BFormGroup,
  BInputGroupPrepend,
  BInputGroup,
  BSpinner,
  BPagination,
  BBadge,
  BFormCheckbox,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BForm,
    BFormInput,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BSpinner,
    BPagination,
    BBadge,
    BFormCheckbox,
    vSelect,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      dataLoading: false,
      items: [],
      fields: [
        { key: "title", label: "Title" },
        { key: "number", label: "Number" },
        { key: "sendOn", label: "Send on" },
        { key: "actions", label: "Actions" },
      ],
      searchQuery: "",
      smsLoading: false,
      smsOptions: [],
      request: false,
      myObj: {
        id: 0,
        sendOn: "",
        smsSettingID: 0,
        classIDs: [],
        campusID: this.$store.state.userData.cId,
      },
      clsLoading: false,
      classes: [],
      classesOptions: [],
      sendOptions: [
        { text: "None", value: "" },
        { text: "Inquiry", value: "inquiry" },
        { text: "Admission", value: "admission" },
        { text: "Fee Challan", value: "fee-challan" },
        { text: "Fee Collection", value: "fee-collection" },
        { text: "Student Attendance", value: "student-attendance" },
        { text: "Staff Attendance", value: "staff-attendance" },
        { text: "Payroll", value: "payroll" },
      ],
    };
  },
  computed: {
    filters: function () {
      return this.items.filter((pro) => {
        return pro.title.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
  },
  created() {
    // this.LoadData();
    this.LoadOptions();
    this.LoadClasses();
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    setClass() {
      if (this.myObj.classIDs.at(-1) == 0) {
        this.myObj.classIDs = [0];
      } else {
        this.myObj.classIDs = this.myObj.classIDs.filter((el) => el != 0);
      }
    },

    AddOpen() {
      this.myObj = {
        id: 0,
        sendOn: "",
        smsSettingID: 0,
        classIDs: [],
        campusID: this.$store.state.userData.cId,
      };
      this.$bvModal.show("modal-sms-mapping");
    },
    EditOpen(obj) {
      this.myObj = { ...obj };
      this.$bvModal.show("modal-sms-mapping");
    },
    CheckSendOn() {
      var elem = this.$refs["send_on"];
      if (!this.myObj.sendOn) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSms() {
      var elem = this.$refs["sms_temp"];
      if (!this.myObj.smsSettingID) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckClass() {
      var elem = this.$refs["sel_cls"];
      if (this.myObj.classIDs.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveData() {
      let s1 = this.CheckSendOn();
      let s2 = this.CheckSms();
      let s3 = this.CheckClass();

      if (!s1 || !s2 || !s3) {
        return this.$bvToast.toast("Please fill the details correctly.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        console.log(this.myObj);
        return;
        this.request = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "SmsMapping/Save?db=" +
            this.$store.state.userData.db,
          body: this.myObj,
          message: "Setting added successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.LoadOptions();
          this.$bvModal.hide("modal-sms-mapping");
        }
      }
    },

    async LoadClasses() {
      this.clsLoading = true;
      var obj2 = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      this.classes = await this.get(obj2);
      this.classesOptions = this.classes.map((el) => el.cls);
      this.clsLoading = false;
    },
    async LoadOptions() {
      this.smsLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "SmsSettings?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.smsOptions = await this.get(obj);
      this.smsLoading = false;
    },
    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "SmsMapping?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);
      this.dataLoading = false;
    },
  },
};
</script>
<style></style>
